import * as React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Slide,
  TextField,
  Theme,
  withStyles,
} from "@material-ui/core";
import { API } from "aws-amplify";
import { TransitionProps } from "@material-ui/core/transitions";
import { LoadingSpinner } from "../../../../../../utils/LoadingSpinner";
import AddDrugResult from "./AddDrugResult";

const styles = ({ spacing }: Theme) =>
  createStyles({
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
  });

interface IAddDrugState {
  drugIdorNdc11: string;
  formSubmitted: boolean;
  message: string;
  open: boolean;
  response: string;
  resultSuccessful: boolean;
}

const TransitionConst = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class AddDrugSection extends React.Component<any, IAddDrugState> {
  constructor(props: any) {
    super(props);
    this.state = {
      drugIdorNdc11: "",
      formSubmitted: false,
      message: "",
      open: false,
      response: "",
      resultSuccessful: false,
    };

    this.handleDrugIdorNdc11 = this.handleDrugIdorNdc11.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  public render() {
    return (
      <Grid item xs={12}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={3}
        >
          <Grid item xs>
            <TextField
              required
              label="Drug Id or NDC11"
              variant="outlined"
              value={this.state.drugIdorNdc11}
              onChange={this.handleDrugIdorNdc11}
            />
          </Grid>

          <Grid item xs>
            <Button
              variant="outlined"
              color="default"
              onClick={this.handleSubmit}
            >
              Submit
            </Button>
          </Grid>

          <Grid item xs={12}>
            {this.state.formSubmitted && <LoadingSpinner />}
            {this.state.resultSuccessful && (
              <AddDrugResult
                resultSuccessful={this.state.resultSuccessful}
                response={this.state.response}
              />
            )}
          </Grid>

          {this.state.message && (
            <Dialog
              open={this.state.open}
              TransitionComponent={TransitionConst}
              keepMounted
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              onClose={this.handleClose}
            >
              <DialogTitle id="alert-dialog-slide-title">
                {"Add Drug Response"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {this.state.message}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </Grid>
      </Grid>
    );
  }

  public handleClose() {
    this.setState({ open: false });
  }

  public handleDrugIdorNdc11(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ drugIdorNdc11: event.target.value });
  }

  private handleValidation() {
    let formIsValid = true;
    if (!this.state.drugIdorNdc11) {
      alert("Please enter the drug id or NDC11");
      formIsValid = false;
    }
    return formIsValid;
  }

  private handleSubmit() {
    if (this.handleValidation()) {
      this.setState({ formSubmitted: true });
      this.setState({ resultSuccessful: false });

      const apiName = "ApaqPortalAPI";
      const path = "/drug/create";
      const config = {
        body: {
          input: this.state.drugIdorNdc11,
        },
        headers: {},
      };

      API.post(apiName, path, config)
        .then((response) => {
          console.log(response);
          this.setState({ resultSuccessful: true });
          this.setState({ formSubmitted: false });
          this.setState({ drugIdorNdc11: "" });
          this.setState({ response: response.details });
        })
        .catch((error) => {
          console.log(error);
          this.setState({ open: true });
          this.setState({ formSubmitted: false });
          this.setState({ message: error.response.data.message });
        });
    }
  }
}

export default withStyles(styles)(AddDrugSection);
